




import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {PickingListReTransportStatus} from "@/enums/status";
import {IdMapper} from "@/interfaces/state/base";

@Component({
  name: 'PLReTransportStatusLabel'
})
export default class extends mixins(CommonMixin) {
  @Prop({ required: true, type: Number }) readonly status!: number;
  PickingListReTransportStatus = PickingListReTransportStatus;
  colorMap: IdMapper<string> = {
    [PickingListReTransportStatus.WaitingConfirm]: 'warning',
    [PickingListReTransportStatus.Confirmed]: 'blue',
    [PickingListReTransportStatus.Success]: 'success',
    [PickingListReTransportStatus.Reject]: 'error',
  }
}
